<template>
  <a-modal
    :title="title"
    :width="800"
    :ok="false"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构名称" :hidden="false" hasFeedback>
          <a-input
            id="departName"
            placeholder="请输入机构/部门名称"
            v-decorator="['departName', validatorRules.departName]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" label="上级部门" hasFeedback>
          <a-tree-select
            style="width: 100%"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="departTree"
            v-model="model.parentId"
            placeholder="请选择上级部门"
            :disabled="condition"
          ></a-tree-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构类型">
          <template v-if="seen">
            <a-radio-group v-decorator="['orgCategory', validatorRules.orgCategory]" placeholder="请选择机构类型">
              <a-radio value="1">公司</a-radio>
            </a-radio-group>
          </template>
          <template v-else>
            <a-radio-group v-decorator="['orgCategory', validatorRules.orgCategory]" placeholder="请选择机构类型">
              <a-radio value="2">部门</a-radio>
              <a-radio value="3">岗位</a-radio>
            </a-radio-group>
          </template>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构编码">
          <a-input placeholder="请输入机构编码" v-decorator="['orgCode', validatorRules.orgCode]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话">
          <a-input placeholder="请输入电话" v-decorator="['mobile', validatorRules.mobile]" />
        </a-form-item>
        <!-- 部门经理start -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门经理">
          <a-select
            show-search
            v-decorator="['deptLeaderId', {}]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleMangerSearch"
            @change="onChangeManager"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in DepartMangerList" :key="index" :value="item.deptLeaderId">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 部门经理end -->
        <!---- 分管领导start =======------>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分管领导">
          <a-select
            show-search
            v-decorator="['fgLeaderId', {}]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleLeaderSearch"
            @change="onChangeLeader"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in leaderList" :key="index" :value="item.fgLeaderId">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!---- 分管领导end------>
        <!---- 主管会计start =======------>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="主管会计">
          <a-select
            show-search
            v-decorator="['zgkjId', {}]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleaccountantSearch"
            @change="onChangeaccountant"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in accountantList" :key="index" :value="item.zgkjId">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!---- 主管会计end------>
        <!---- 退款会计start =======------>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款会计">
          <a-select
            show-search
            v-decorator="['tkkjId', {}]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleRefundSearch"
            @change="onChangeRefund"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in refundList" :key="index" :value="item.tkkjId">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!---- 退款会计end------>
        <!---- 事业部负责人start =======------>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="事业部负责人">
          <a-select
            show-search
            v-decorator="['buManagerId', {}]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleBusSearch"
            @change="onChangeBus"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option v-for="item in busUnitHead" :key="item.buManagerId" :value="item.buManagerId">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!---- 事业部负责人end------>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话">
          <a-input placeholder="请输入电话" v-decorator="['mobile', validatorRules.mobile]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="传真">
          <a-input placeholder="请输入传真" v-decorator="['fax', {}]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址">
          <a-input placeholder="请输入地址" v-decorator="['address', {}]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
          <a-input-number v-decorator="['departOrder', { initialValue: 0 }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-textarea placeholder="请输入备注" v-decorator="['memo', {}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import { queryIdTree, getUserList } from '@/api/api'
import pick from 'lodash.pick'
import ATextarea from 'ant-design-vue/es/input/TextArea'
export default {
  name: 'SysDepartModal',
  components: { ATextarea },
  data() {
    return {
      defaulManger: [],
      DepartMangerList: [], //部门经理下拉菜单
      leaderList: [], //分管领导下拉菜单
      accountantList: [], //主管会计下拉菜单
      refundList: [], //退款会计下拉菜单
      busUnitHead: [], //事业部负责人
      departTree: [],
      orgTypeData: [],
      phoneWarning: '',
      departName: '',
      title: '操作',
      seen: false,
      visible: false,
      condition: true,
      disableSubmit: false,
      model: {},
      menuhidden: false,
      menuusing: true,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        departName: {
          rules: [{ required: true, message: '请输入机构/部门名称!' }]
        },
        orgCode: { rules: [{ required: true, message: '请输入机构编码!' }] },
        mobile: { rules: [{ validator: this.validateMobile }] }
      },
      url: {
        add: '/api/sys/sysDepart/add'
      },
      dictDisabled: true
    }
  },
  created() {
    this.getMangerMenu()
    this.getLeaderMenu()
    this.getAccountantMenu()
    this.getTkkjIdMenu()
    this.getBusUnitHead()
  },
  methods: {
    //0010d598a8474226941fffca5d930a9f
    // 获取部门经理下拉菜单
    getMangerMenu(value) {
      let params = {
        // pageNo: 1,
        // pageSize: 10,
        username: value ? value : ''
      }
      getUserList(params).then((res) => {
        console.log(res)
        let resp = res.result.records
        resp.map((el) => {
          this.DepartMangerList.push({
            realname: el.realname,
            deptLeaderId: el.id
          })
        })
      })
    },
    // 获取分管领导下拉菜单
    getLeaderMenu(value) {
      let params = {
        // pageNo: 1,
        // pageSize: 10,
        username: value ? value : ''
      }
      getUserList(params).then((res) => {
        let resp = res.result.records
        resp.map((el) => {
          this.leaderList.push({
            realname: el.realname,
            fgLeaderId: el.id
          })
        })
      })
    }, // 获取主管会计下拉菜单
    getAccountantMenu(value) {
      let params = {
        // pageNo: 1,
        // pageSize: 10,
        username: value ? value : ''
      }
      getUserList(params).then((res) => {
        console.log(res)
        let resp = res.result.records
        resp.map((el) => {
          this.accountantList.push({
            realname: el.realname,
            zgkjId: el.id
          })
        })
        // console.log(this.DepartMangerList);
      })
    },
    // 获取退款会计下拉菜单
    getTkkjIdMenu(value) {
      let params = {
        // pageNo: 1,
        // pageSize: 10,
        username: value ? value : ''
      }
      getUserList(params).then((res) => {
        console.log(res)
        let resp = res.result.records
        resp.map((el) => {
          this.refundList.push({
            realname: el.realname,
            tkkjId: el.id
          })
        })
      })
    },
    // 获取事业部负责人下拉菜单
    getBusUnitHead(value) {
      let params = {
        // pageNo: 1,
        // pageSize: 10,
        username: value ? value : ''
      }
      getUserList(params).then((res) => {
        console.log(res)
        let resp = res.result.records
        resp.map((el) => {
          this.busUnitHead.push({
            realname: el.realname,
            buManagerId: el.id
          })
        })
      })
    },
    // 部门经理
    onChangeManager(value) {
      console.log(value)
    },
    handleMangerSearch(value) {
      this.DepartMangerList = []
      this.getMangerMenu(value)
    },
    // 分管领导
    onChangeLeader(value) {
      console.log(value)
    },
    handleLeaderSearch(value) {
      this.leaderList = []
      this.getLeaderMenu(value)
    },
    // 主管会计
    onChangeaccountant(value) {
      console.log(value)
    },
    handleaccountantSearch(value) {
      this.accountantList = []
      this.getAccountantMenu(value)
    },
    // 退款会计
    onChangeRefund(value) {
      console.log(value)
    },
    handleRefundSearch(value) {
      this.refundList = []
      this.getTkkjIdMenu(value)
    },
    // 事业部负责人
    onChangeBus(value) {},
    handleBusSearch(value) {
      this.busUnitHead = []
      this.getBusUnitHead(value)
    },
    loadTreeData() {
      var that = this
      queryIdTree().then((res) => {
        if (res.success) {
          that.departTree = []
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.departTree.push(temp)
          }
        }
      })
    },
    add(depart) {
      if (depart) {
        this.seen = false
        this.dictDisabled = false
      } else {
        this.seen = true
        this.dictDisabled = true
      }
      this.edit(depart)
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, {})
      this.visible = true
      this.loadTreeData()
      this.model.parentId = record != null ? record.toString() : null
      if (this.seen) {
        this.model.orgCategory = '1'
      } else {
        this.model.orgCategory = '2'
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'orgCategory',
            'departName',
            'departNameEn',
            'departNameAbbr',
            'departOrder',
            'description',
            'orgType',
            'orgCode',
            'mobile',
            'fax',
            'address',
            'memo',
            'status',
            'delFlag'
          )
        )
      })
    },
    close() {
      this.$emit('close')
      this.disableSubmit = false
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(this.model, values)
          //时间格式化
          console.log(formData)
          httpAction(this.url.add, formData, 'post')
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadTreeData()
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback()
      } else {
        callback('您的手机号码格式不正确!')
      }
    }
  }
}
</script>

<style scoped></style>
